import styled from "styled-components";
import { deviceSizesMin } from "../../../../../../DeviceSizes";

export const ArticleSliderLink = styled.a``;

export const ArticleSliderContainer = styled.div`
  position: relative;
  display: block;

  height: calc(80vh - 72px);
`;

export const ArticleSliderLeft = styled.img`
  position: absolute;
  left: 5px;
  top: 50%;

  height: 50px;
  width: 50px;

  transform: translateY(-50%) rotate(90deg);

  opacity: 50%;

  cursor: pointer;

  &:hover {
    opacity: 75%;
  }

  @media only screen and ${deviceSizesMin.laptop} {
    left: 15px;

    height: 100px;
    width: 100px;
  }
`;

export const ArticleSliderDescription = styled.div`
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.5);

  position: absolute;
  bottom: 30px;

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media screen and ${deviceSizesMin.laptop} {
    min-width: 350px;
    width: auto;

    height: 70px;
    background: rgba(0, 0, 0, 0.5);

    position: absolute;
    bottom: 50px;
    transform: translateY(-50%);
    margin-left: 50px;

    display: flex;
    text-align: left;
  }
`;

export const ArticleSliderTitle = styled.a`
  color: white;
  font-size: 1em;
  font-weight: bold;
  text-decoration: none;
  width: 100%;
  text-align: center;

  @media only screen and ${deviceSizesMin.laptop} {
    display: inline-block;

    margin-left: 10px;
    color: white;
    font-size: 1.5em;
    font-weight: bold;
    text-decoration: none;
    width: auto;

    flex: 0 0 100%;
    text-align: left;
  }
`;

export const ArticleSliderAuthor = styled.p`
  color: white;
  width: 100%;
  text-align: center;
  font-size: 12px;

  @media only screen and ${deviceSizesMin.laptop} {
    text-align: left;

    margin-left: 10px;

    margin-top: 0px;
  }
`;

export const ArticleSliderPrev = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);

  opacity: 0.5;

  width: 75px;
  height: 75px;

  background: url(${(props) => props.icon}) 100% 50% no-repeat;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

export const ArticleSliderItem = {
  Container: styled.div`
    position: relative;
    min-height: 310px;
    height: calc(50vh - 72px);
    overflow-y: hidden;
    margin-bottom: 0 !important;

    background: url(${(props) => props.image}) no-repeat center;
    background-size: cover;

    @media only screen and ${deviceSizesMin.laptop} {
      position: relative;
      height: calc(80vh - 72px);
      overflow-y: hidden;
      margin-bottom: 0 !important;

      background: url(${(props) => props.image}) no-repeat;
      background-size: cover;

      width: 100vw;
    }
  `,
  Description: styled.div``,
  LinkWrapper: styled.a``,
};
